<template>
  <div>
    <h1>Insights</h1>
    <v-container
      fluid
      pa-0
      class="d-flex justify-end"
    >
      <div
        class="button-container d-flex justify-space-between pa-0 mx-0"
      >
        <v-menu
          offset-y
          left
          rounded="lg"
          :content-class="'add-button-menu'"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                depressed
                dark
                color="#188D83"
                class="add-button"
                v-bind="attrs"
                v-on="on"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
                v-for="(item, index) in addButtonItems"
                :key="index"
            >
              <v-list-item-title
                @click="addButtonAction(item.property)"
              >
                <v-icon>
                  {{ item.icon }}
                </v-icon>
                {{ item.label }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          depressed
          dark
          color="#188D83"
          class="edit-button"
        >
          Edit
        </v-btn>
      </div>
    </v-container>

    <add-section :isModalVisible="addSectionVisible" @modalClose="addSectionVisible = $event" />
  </div>
</template>

<script>
import AddSection from './modals/addSection'

  export default {
    components: {
      AddSection
    },
    data() {
      return {
        addSectionVisible: false,
        addButtonItems: [
          {
            icon: 'mdi-text-box-plus-outline',
            label: 'Create Card',
            property: ''
          },
          {
            icon: 'mdi-file-upload-outline',
            label: 'Import Card',
            property: ''
          },
          {
            icon: 'mdi-plus',
            label: 'Add Section',
            property: 'addSectionVisible'
          },
        ]
      }
    },
    methods: {
      addButtonAction(button) {
        this[button] = !this[button]
      }
    }
  }
</script>

<style lang="sass">
  .button-container
    width: 170px
    .add-button
      width: 50px
      min-width: 50px
      height: 50px
      min-height: 50px
    .edit-button
      width: 100px
      min-width: 100px
      height: 50px
      min-height: 50px

  .add-button-menu
    top: 145px !important
    left: 1196px !important
    .v-list-item
      cursor: pointer
</style>
